import { Steps, Step } from 'components/Docs/Steps';
import CLIUpload from "../../../../contents/docs/error-tracking/_snippets/cli/upload.mdx";
import CLIAuthenticate from "../../../../contents/docs/error-tracking/_snippets/cli/authenticate.mdx";
import CLIDownload from "../../../../contents/docs/error-tracking/_snippets/cli/download.mdx";
import InstallNuxt from "../../../../contents/docs/integrate/_snippets/install-nuxt.mdx";
import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSourceMaps from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-source-maps.tsx";
import * as React from 'react';
export default {
  Steps,
  Step,
  CLIUpload,
  CLIAuthenticate,
  CLIDownload,
  InstallNuxt,
  StepVerifyErrorTracking,
  StepUploadSourceMaps,
  React
};